import { Brand } from "./brand.js";
import * as pm from "./pmBrand.js";
import { Term } from "./item.js";

/*
  example:
  condition: {sec:['V1','V2'], brand:['ポッピンハート']}
*/
export interface FilterCondition {
  name?: string[];
  sec?: string[];
  star?: string[];
  brand?: Brand[] | pm.Brand[];
  term?: Term[];
  check?: CheckCondition[];
  scope?: "local" | "global";
}

export const checkConditions = [
  "COMP",
  "1 left",
  "2 left",
  "3 left",
  "4 left",
  "don't have",
  "no QR",
  "exist QR",
] as const;
export type CheckCondition = (typeof checkConditions)[number];
